// import React, { useState } from "react";
// import { Dashboard } from "../Dashboard/Dashboard";
// import AdminSidebar from "../Sidebar/AdminSidebar";
// import Department from "../Department/Department";
// import Employee from "../Employee/Employee";
// import Devices from "../Devices/Devices";

// const AdminLayout = () => {
//     const [activePage, setActivePage] = useState("dashboard");

//     const renderPage = () => {
//         switch (activePage) {
//             case "dashboard":
//                 return <Dashboard />;
//             case "department-menu":
//                 return <Department />;
//             case "employ":
//                 return <Employee />;

//             case "Devices":
//                 return <Devices/>;
      
//             default:
//                 return <Dashboard />;
//         }
//     };

//     return (
//         <>
//             <div style={{ display: "flex", minHeight: "100vh" }}>
//                 <AdminSidebar
//                     activePage={activePage}
//                     onPageChange={setActivePage}
//                 />
//                 <div style={{ flex: 1 }}>{renderPage()}</div>
//             </div>
//         </>
//     );
// };

// export default AdminLayout;


import React, { useState, useEffect } from "react";
import { Dashboard } from "../Dashboard/Dashboard";
import AdminSidebar from "../Sidebar/AdminSidebar";
import Department from "../Department/Department";
import Employee from "../Employee/Employee";
import Devices from "../Devices/Devices";
import { Menu, X } from "lucide-react"; 
import { colors } from "../utils/theme";
import Sessions from "../Sessions/Sessions";
import EmployeeTracker from "../EmployeeTracker/EmployeeTracker";

const AdminLayout = () => {
    const [activePage, setActivePage] = useState("dashboard");
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    // Update state on window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            if (!mobile) setIsMobileMenuOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const renderPage = () => {
        switch (activePage) {
            case "dashboard": return <Dashboard />;
            case "department-menu": return <Department />;
            case "employ": return <Employee />;
            case "Devices": return <Devices />;
            case "Sessions":return <Sessions/>;
            case "Employees Tracker": return<EmployeeTracker/>;
            default: return <Dashboard />;
        }
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh", backgroundColor: colors.background }}>
            
            {/* MOBILE HAMBURGER - Now using standard 'button' */}
            {isMobile && (
                <button 
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    style={styles.mobileToggle}
                >
                    {isMobileMenuOpen ? <X size={24} color="#fff" /> : <Menu size={24} color="#fff" />}
                </button>
            )}

            {/* SIDEBAR CONTAINER */}
            <div style={{
                position: isMobile ? "fixed" : "relative",
                zIndex: 1000,
                // On mobile, slide in from left; on desktop, stay put
                transform: isMobile && !isMobileMenuOpen ? "translateX(-100%)" : "translateX(0)",
                transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                height: "100vh",
                boxShadow: isMobile && isMobileMenuOpen ? "10px 0 30px rgba(0,0,0,0.1)" : "none"
            }}>
                <AdminSidebar
                    activePage={activePage}
                    onPageChange={(page) => {
                        setActivePage(page);
                        if (isMobile) setIsMobileMenuOpen(false); // Close drawer on selection
                    }}
                />
            </div>

            {/* DARK OVERLAY (Mobile Only) */}
            {isMobile && isMobileMenuOpen && (
                <div 
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={styles.overlay}
                />
            )}

            {/* MAIN WORK AREA */}
            <main style={{ 
                flex: 1, 
                width: "100%",
                // This is key for responsiveness: allows internal tables to scroll but keeps layout intact
                overflowX: "hidden", 
                paddingTop: isMobile ? 70 : 0 
            }}>
                <div style={styles.viewContainer}>
                    {renderPage()}
                </div>
            </main>
        </div>
    );
};

const styles = {
    mobileToggle: {
        position: "fixed",
        top: 15,
        right: 15,
        zIndex: 1100,
        backgroundColor: "#dd3537", // colors.primary
        border: "none",
        width: 50,
        height: 50,
        borderRadius: 14,
        boxShadow: "0 8px 20px rgba(221, 53, 55, 0.3)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        backdropFilter: "blur(4px)",
        zIndex: 999
    },
    viewContainer: {
        maxWidth: "1600px",
        margin: "0 auto",
        width: "100%",
        // Adds consistent breathing room for yosur cards
    }
};

export default AdminLayout;